import { type FunctionComponent, Fragment } from 'react';
import { type ProductSale } from '../../../types/product.types';
import { GreyBox } from '../../common-components/grey-box/grey-box.component';
import SellIcon from '../../svgs/sell.svg';

export type ProductSaleBannerProps = {
	productSales: ProductSale[];
};

export const ProductSaleBanner: FunctionComponent<ProductSaleBannerProps> = ({ productSales }) => {
	return (
		<>
			{productSales.map((sale, index) => {
				return (
					<Fragment key={index}>
						<GreyBox className={'mt3 lh-copy dn db-ns'}>
							<div className={'b theme-grey-darker'}>
								<SellIcon className={'theme-accent mr1'} /> {sale.title}
							</div>
							<div className={'f5 theme-grey-darker pl4'}>{sale.description}</div>
							<div className="f6 pl4">Offer Ends {sale.formattedExpirationDate?.formatted}</div>
						</GreyBox>
						<div className="db dn-ns mt3 pv3 lh-copy bt bb b--theme-grey-light">
							<div className={'b theme-grey-darker'}>
								<SellIcon className={'theme-accent mr1'} /> {sale.title}
							</div>
							<div className={'f5 theme-grey-darker pl4'}>{sale.description}</div>
							<div className="f6 pl4">Offer Ends {sale.formattedExpirationDate?.formatted}</div>
						</div>
					</Fragment>
				);
			})}
		</>
	);
};
